import useBrToHTML from "hooks/useBrToHTML";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  TextBox,
  Text1,
  Text2,
  Table1,
  ContentBox,
  ContentContainer,
  Content1,
  Content2,
  ContentText1,
  ContentText2,
} from "./style";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
import { useNavigatePage } from "hooks/useNavigatePage";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com3 = () => {
  const { t } = useTranslation("home");
  const brToHTML = useBrToHTML;
  const nav = useNavigatePage();

  const language = useSelector(selectLanguage);
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  useScrollFadeIn(ref1, ref2, ref3, ref4);
  return (
    <Container>
      <TextBox>
        <Text1>{t("3-1")}</Text1>
        <Text2>
          <span>{t("3-2")}</span>
          <span>{t("3-2-1")}</span>
          <span>{t("3-3")}</span>
        </Text2>
      </TextBox>
      <Table1>
        <ContentBox ref={ref1} className="fade-in">
          <ContentContainer>
            <Content1>
              <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/84783115Home_11.svg" alt="" />
              <ContentText1 language={language}>{t("3-4")}</ContentText1>

              <ContentText2>
                <span>{t("3-5")}</span>
                <span> {t("3-6")}</span>
              </ContentText2>
            </Content1>
            <Content2 onClick={() => nav("/how_to_get_sketch")}>
              <span>{t("3-7")}</span>
            </Content2>
          </ContentContainer>
        </ContentBox>
        <ContentBox ref={ref2} className="fade-in">
          <ContentContainer>
            <Content1>
              <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/3f1a004cHome_5.svg" alt="" />
              <ContentText1 language={language}>{t("3-8")}</ContentText1>
              <ContentText2>
                <span>{t("3-9")}</span>
                <span>{t("3-10")}</span>
                <span>{t("3-10-1")}</span>
              </ContentText2>
            </Content1>
            <Content2 onClick={() => nav("/sketch_wallet")}>
              <span>{t("3-7")}</span>
            </Content2>
          </ContentContainer>
        </ContentBox>
        <ContentBox ref={ref3} className="fade-in">
          <ContentContainer>
            <Content1>
              <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/612c1a3dHome_6.svg" alt="" />
              <ContentText1 language={language}>{t("3-11")}</ContentText1>
              <ContentText2>
                <span>{t("3-12")}</span>
                <span>{t("3-13")}</span>
              </ContentText2>
            </Content1>
            <Content2 onClick={() => nav("/sketch_pay")}>
              <span>{t("3-7")}</span>
            </Content2>
          </ContentContainer>
        </ContentBox>
        <ContentBox ref={ref4} className="fade-in">
          <ContentContainer>
            <Content1>
              <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/9a917f27Home_7.svg" alt="" />
              <ContentText1 language={language}>{t("3-14")}</ContentText1>
              <ContentText2>
                <span>{t("3-15")}</span>
                <span>{t("3-16")}</span>
                <span>{t("3-17")}</span>
              </ContentText2>
            </Content1>
            <Content2 onClick={() => nav("/who_is_creator")}>
              <span>{t("3-7")}</span>
            </Content2>
          </ContentContainer>
        </ContentBox>
      </Table1>
    </Container>
  );
};

export default Com3;
